import { MDBAlert, MDBBtn, MDBCol, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow, MDBSpinner, MDBTypography } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import uploadIcon from "../../../components/images/upload.svg";
import { getAccountContact, getSpecificContactsDetails } from '../../../apiclients/streamsapi_bridge';
import PopupLoaderNew from '../../../views/popups/PopupLoaderNew';
import AddAccContacts from '../../../views/popups/globalaccount/AddAccContacts';
import PopupLoader from '../../../views/popups/PopupLoader';
import DeleteAccContact from '../../../views/popups/globalaccount/DeleteAccContact';
import { formattedNumber } from '../../../views/popups/phonenumbers/AddRemoveNumbers';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../CustomSearchUtil/CustomSearch';
import UIConstant from '../../../apiclients/UIConstant';
import TabIDConstant from '../../../apiclients/TabIDConstant';

function AccountContacts({isActive}) {
    const { t, i18n } = useTranslation();
    const [centredModal, setCentredModal] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);
    const [basicModal, setBasicModal] = useState(false);
    const toggleOpen2 = () => setBasicModal(!basicModal);

    const [centredModal2, setCentredModal2] = useState(false);
    const toggleOpen3 = () => setCentredModal2(!centredModal2);
    const previewRef = useRef(null);
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [accContacts, setaccContacts] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [deleteID, setdeleteID] = useState([]);
    const addContactRef = useRef(null);
    const [deleteContact, setDeleteContact] = useState(false);
    const [contactDetailsInfo, setcontactDetailsInfo] = useState({})
    const dtogglePopup = () => setDeleteContact(!deleteContact);
    const [editFlag, seteditFlag] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    const [searchValue, setsearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [rowdata, setRowData] = useState([]);

useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)

    function handleClick() {
        addContactRef.current.click();
    }


    const handleDragOver = (event) => {
        event.preventDefault();
        document
            .getElementById("uploadFile")
            .parentNode.classList.add("draging", "dragBox");
    };

    const handleDrop = (event) => {
        event.preventDefault();
        document
            .getElementById("uploadFile")
            .parentNode.classList.remove("draging");
        document.getElementById("uploadFile").parentNode.classList.add("dragBox");
        const file = event.dataTransfer.files[0];
        previewImage(file);
    };

    const previewImage = (file) => {
        const previewDiv = previewRef.current;

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const previewImage = document.createElement("img");
                previewImage.src = reader.result;
                previewDiv.innerHTML = "";
                previewDiv.appendChild(previewImage);
            };
            reader.readAsDataURL(file);
        } else {
            previewDiv.innerHTML = "";
        }
    };

    useEffect(() => {
        if(isActive) {
        getAccContacts();
        }

    }, [isActive]);

    async function getAccContacts() {
        try {
            setInternalError(false);
            setIsloading(true);
            console.log(sessionStorage.getItem("admin_session"));
            const response = await getAccountContact(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.CONTACTS_SUBLINK
            );
            setIsloading(false);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                setInternalError(true);
            }
            console.log("setaccContacts data :::::::::: " + JSON.stringify(rawData));
            setaccContacts(rawData?.getAllContactDtls ?? []);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);

        } catch (error) {

        }
    }
    async function handleDelete(e, id) {
        e.preventDefault();
        e.stopPropagation();
        setdeleteID([parseInt(id)]);
        setDeleteContact(true)
    }

    useEffect(() =>{ 
    let processdrows = [];
    accContacts.map((contact) => {
        let mobilePhone =  formattedNumber(contact?.mobile_phone) ?? "";
        let homePhone = formattedNumber(contact?.home_phone)?? "";
        let OfficePhone = formattedNumber(contact?.office_phone) ?? "";
        processdrows.push({
            contactInfo: contact,
            name: `${contact?.first_name ?? ""} ${contact?.last_name ?? ""}`.trim(),
            email: contact?.email_id?.toString() ?? "",
            contact: contact.contact_type + "",
            actualNumber: mobilePhone?.toString()?.replace(/[ ]/g, '') ?? "",
            actualNumberOne: homePhone?.toString()?.replace(/[ ]/g, '') ?? "",
            actualNumberTwo: OfficePhone?.toString()?.replace(/[ ]/g, '') ?? "",
            mobile:  mobilePhone,
            home: homePhone ?? "",
            Office: OfficePhone ?? "",
            owner: contact?.owner?.toString() ?? "",
            mobile_phone: contact?.mobile_phone ?? "",
            home_phone : contact?.home_phone ?? "",
            office_phone : contact?.office_phone ?? "",
            action: (
                <>
                    <div className="d-flex align-items-center ms-2">
                        <div className="custom-hover-bg p-1 ms-2 cursor-pointer deleteToolTip" onClick={(e) => handleDelete(e, contact.id)}>
                            <MDBIcon fas icon="times" color="primary" className="mx-2 my-1 fs-5" />
                        </div>
                    </div>
                </>
            ),



        })
    });
    setRowData(processdrows);
    setFilteredRows(processdrows)
    setDataLoaded(true)
},[accContacts])


    const actionData = {
        columns: [
            { label: 'Name', field: 'name', sort: true },
            { label: 'Email', field: 'email' },
            { label: 'Contact Type', field: 'contact' },
            { label: 'Mobile Phone', field: 'mobile' },
            { label: 'Home Phone', field: 'home' },
            { label: 'Office Phone', field: 'Office' },
            { label: 'Owner', field: 'owner' },
            { label: 'Action', field: 'action', sort: false },
        ],
        rows: rowdata,
    };

    const showThisInfo = (e) => {
        seteditFlag(true);
        setcontactDetailsInfo({});
        getSpecificContact(e.contactInfo.id);
        toggleOpen();
    }

    async function getSpecificContact(id) {
        try {
            setInternalError(false);
            setIsloading(true);
            console.log(sessionStorage.getItem("admin_session"));
            const response = await getSpecificContactsDetails(JSON.parse(sessionStorage.getItem("admin_session")).siteid, id);
            setIsloading(false);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                setInternalError(true);
            }

            let contactsInfo = rawData?.contacts_info[0] ?? {}
            contactsInfo = { ...contactsInfo, custom_fields: rawData?.custom_fields ?? [] };

            console.log("setcontactDetailsInfo data :::::::::: " + JSON.stringify(contactsInfo));
            setcontactDetailsInfo(contactsInfo ?? {});
            setTimeout(() => {
                setIsloading(false);
            }, 1000);

        } catch (error) {

        }

    }


    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(rowdata, searchValue, UIConstant.ACCOUNT_CONTACTS);

        setFilteredRows(filteredUsers);
    };

    const handleAddContact = () => {
        seteditFlag(false);
        setcontactDetailsInfo({});
        toggleOpen();
    };

  
    return (
        <>
            <div>
                <div className=" actionbar button_aligniment">
                    {/* <MDBBtn className="float-end" onClick={toggleOpen2}><MDBIcon fas icon="plus" className="me-2" />{t("importGlobalContact")}</MDBBtn> */}
                    <MDBBtn className="float-end me-3" onClick={handleAddContact}><MDBIcon fas icon="plus" className="me-2" />{t("addContact")}</MDBBtn>
                </div>
            </div>
            <div className='contactsTable'>
        
                <div className="actionbar"></div>
                <div className='mb-2 mt-2 position-relative w-auto'>
                    <MDBInput ref={searchRef} label="Search" value={searchValue}  onChange={(e) => handleManualSearch(e.target.value)} />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <MDBDatatable hover
                 key={searchValue}
                data={{
                    ...actionData,
                    rows: filteredRows, // Use filtered rows here
                  }}
                sortField="Name" entries={50} onRowClick={(e) => showThisInfo(e)} />
            </div>


            {centredModal && (
                <PopupLoaderNew
                    title={editFlag ? t('editContact') : t('addContact')}
                    content={<AddAccContacts
                        onClose={() => {
                        toggleOpen();
                        seteditFlag(false);
                        setcontactDetailsInfo({});
                    }}
                        ref={addContactRef}
                        setIsloading={setisLoading}
                        contactInfo={editFlag ? contactDetailsInfo : null}
                        editFlag={editFlag}
                    />}
                    onShow={setCentredModal}
                    onClose={() => {
                        toggleOpen();
                        seteditFlag(false);
                        setcontactDetailsInfo({});
                    }}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={editFlag ? 2 : 1}
                />
            )}

            {deleteContact && (
                <PopupLoaderNew
                    title={"Remove Contact"}
                    content={<DeleteAccContact
                        contactId={deleteID}
                        onClose={dtogglePopup}
                        ref={addContactRef}
                        setIsloading={setisLoading}
                    />}
                    onShow={setDeleteContact}
                    onClose={dtogglePopup}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}

            {/* <MDBModal open={basicModal} setShow={setBasicModal} tabIndex='-1'>
                <MDBModalDialog size='md'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>{t('addGlobalContact')}</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleOpen2}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <h5>{t('downloadCSVtmp')}</h5>
                            <MDBBtn className="w-50 mt-3"> <MDBIcon fas icon="arrow-down" className="me-2" />Download Import Global Contach Template</MDBBtn>


                            <MDBTypography className="cursor-pointer my-3" onClick={toggleOpen3} >
                                <MDBTypography tag='u'>Instructions to fill the Enterprise Administration Template correctly</MDBTypography>
                            </MDBTypography>
                            <h5>{t('Uploaddoc')}</h5>
                            <div>
                                <div className="uploadOuter">
                                    <span
                                        className="dragBox2 upload-content"
                                        onDragOver={handleDragOver}
                                        onDrop={handleDrop}
                                    >
                                        <span>
                                            <img src={uploadIcon} className="upload-img" />
                                        </span>
                                        <span>Drag and Drop to upload Files</span>


                                        <input
                                            type="file"
                                            // onChange={handleChange}
                                            id="uploadFile"
                                            className="upload__img"
                                        />
                                    </span>
                                </div>

                                <p className="text-danger mt-3">
                                    <b className="text-danger"> Note:</b>
                                    <ol>
                                        <li className="text-danger">Spread Sheet can contain a maximum of 10000 contacts to be uploaded</li>
                                        <li className="text-danger">Select a csv file from your local machine to import contacts</li>
                                        <li className="text-danger">Make sure the header [First Name, Last Name, Email, Cell Phone...] is the first row of the file</li>
                                    </ol>
                                </p>
                            </div>

                            <MDBModal tabIndex='-1' open={centredModal2} setShow={setCentredModal2}>
                                <MDBModalDialog centered>
                                    <MDBModalContent>
                                        <MDBModalHeader>
                                            <MDBModalTitle>{t("instructions")}</MDBModalTitle>
                                            <MDBBtn className='btn-close' color='none' onClick={toggleOpen3}></MDBBtn>
                                        </MDBModalHeader>
                                        <MDBModalBody>
                                            <ul>
                                                <li>To create a user, you need to enter mandatory fields like First Name, Email Address, User ID, and Service Plan.
                                                    <b> Note:</b>If you need to configure an IP Phone for a user, you need to enter IP Phone Mac ID, IP Phone Make (need to be
                                                    selected from the drop-down list) and 911 location (if you do not have a 911 location already added, please go to Account Level Service Manager &gt;911 Locations and add), else these fields are optional. Extension, Password and Voicemail PIN fields will be auto-generated, if they are found to be empty.</li>
                                                <li>
                                                    First Name and Last Name can contain only alphabets and should not exceed 30 characters in case of First Name and 20 characters in case of Last Name.
                                                </li>
                                                <li>Email ID can contain alphanumeric characters with globally approved special characters like _, -, . and should not exceed 50 characters, e.g.: sally24_doe@mycompany.com
                                                </li>
                                                <li>User ID should be unique and should contain alphabets in lower case and should not exceed 50 characters, e.g. sallyjohn</li>
                                                <li>Voicemail PIN should contain only numeric characters and the length of the PIN should be 5 or 6 digits.
                                                </li>
                                                <li>Extension number should be unique. The length of your extension is: 4.
                                                    Note : All 999X extensions are Reserved.</li>
                                                <li>Service Plan Name should be as per norms [WS-Element, WS-Communicator, WS-Call Center, PowerPak Enterprise-1,Common Seat, Virtual Extension, Virtual Extension Unlimited, Business Voice, Business Voice Basic, WS-UCC, SmartBox Enterprise, Call Routing]. Please select the same from the drop-down provided in Spread sheet. Also please do not enter any customized information.</li>
                                                <li>DID should contain only numeric characters and the length of DID should be 10 or 11 digits and the DID must be purchased before placing in spread sheet.</li>
                                                <li>Select "Yes" to allow user to make International/Local Calls or "No" to allow user to make Local Calls only.</li>
                                            </ul>
                                        </MDBModalBody>
                                    </MDBModalContent>
                                </MDBModalDialog>
                            </MDBModal>

                        </MDBModalBody>

                        <MDBModalFooter>
                            <MDBBtn color='secondary' onClick={toggleOpen2}>
                                Close
                            </MDBBtn>
                            <MDBBtn>Save changes</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal> */}

            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}

        </>
    )
}

export default AccountContacts
